"use client";
import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { timings } from '../../../constants/timings.js';
import { setTransitionProps } from '../../helpers/style.js';
import { useClientRect } from '../../hooks/useClientRect.web.js';
import { FloatWrapper } from './styles.js';
import { isIE } from '../../helpers/isIE.js';
import { shadows } from '../../../constants/shadows.js';
import { spacing } from '../../../constants/spacing.js';

var _excluded = ["children", "opened", "anchorPos", "id", "gutter"];
var getPosition = function getPosition(anchorPos, gutter) {
  switch (anchorPos) {
    case 'bottomLeft':
      return {
        marginRight: gutter,
        bottom: gutter,
        left: gutter
      };
    case 'bottomRight':
      return {
        marginLeft: gutter,
        bottom: gutter,
        right: gutter
      };
    case 'topLeft':
      return {
        marginRight: gutter,
        top: gutter,
        left: gutter
      };
    case 'topRight':
      return {
        marginLeft: gutter,
        top: gutter,
        right: gutter
      };
    case 'topCenter':
      return {
        left: '50%',
        right: 'auto',
        top: gutter
      };
    case 'bottomCenter':
      return {
        left: '50%',
        right: 'auto',
        bottom: gutter
      };
  }
};
var Float = function Float(_ref) {
  var children = _ref.children,
    opened = _ref.opened,
    _ref$anchorPos = _ref.anchorPos,
    anchorPos = _ref$anchorPos === undefined ? 'bottomRight' : _ref$anchorPos,
    idProp = _ref.id,
    _ref$gutter = _ref.gutter,
    gutter = _ref$gutter === undefined ? {
      "default": 0,
      m: spacing.s
    } : _ref$gutter,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useClientRect = useClientRect(),
    _useClientRect2 = _slicedToArray(_useClientRect, 2),
    rect = _useClientRect2[0],
    ref = _useClientRect2[1];
  var ie = isIE();
  var calculatedHeight = rect ? rect.height : 0;
  var floatPosition = getPosition(anchorPos, gutter);
  var opacity = opened ? 1 : 0;
  var display = ie && !opened ? 'none' : undefined;
  var transitionProps = !ie ? setTransitionProps({
    transform: timings.slowest,
    opacity: timings.slowest
  }) : [];
  var centeredAnchors = ['topCenter', 'bottomCenter'];
  return /*#__PURE__*/React.createElement(FloatWrapper, _extends({
    ref: ref,
    id: idProp,
    "aria-hidden": !opened,
    "data-testid": "elemental-Float",
    role: "dialog",
    boxShadow: shadows.s,
    position: "fixed",
    zIndex: 10000,
    opacity: opacity,
    display: display,
    minWidth: {
      "default": '100%',
      m: ie ? '28em' : 'auto'
    },
    maxWidth: "100%",
    $calculatedHeight: calculatedHeight,
    $opened: opened,
    $gutter: gutter,
    $floatPosition: floatPosition,
    $isIE: ie,
    $centerHorizontally: centeredAnchors.includes(anchorPos)
  }, floatPosition, transitionProps, props), children);
};

export { Float };
